import * as React from 'react'
import PropTypes from 'prop-types'
import ParagraphSection from './ParagraphSection'
import ParagraphWithStickyImageSection from './ParagraphWithStickyImageSection'
import YoutubeSection from './YoutubeSection'
import FormSection from './FormSection'
import MapSection from './MapSection'
import TaggedLandingPages from './TaggedLandingPages'
import ProductGrid from './ProductGrid'
import HaveQuestionsSection from './HaveQuestionsSection'
import ImageMosaicSection from './ImageMosaicSection'
import AccordionSection from './AccordionSection'
import TestimonialsSection from './TestimonialsSection'
import { CtaLinkSection } from './CtaLink'
import ImageSection from './ImageSection'
import SectionLayout from './SectionLayout'
import NumberedListSection from './NumberedListSection'

const Section = ({ section, className = '', isDark = false, theme = 'Light' }) => {
  const sections = {
    'accordion-section': AccordionSection,
    paragraph: ParagraphSection,
    'paragraph-with-sticky-image': ParagraphWithStickyImageSection,
    'youtube-videos': YoutubeSection,
    testimonials: TestimonialsSection,
    form: FormSection,
    'common-questions': HaveQuestionsSection,
    'product-grid': ProductGrid,
    'image-mosaic': ImageMosaicSection,
    'contact-us-map': MapSection,
    'tagged-landing-pages': TaggedLandingPages,
    'have-questions': HaveQuestionsSection,
    'shared.link': CtaLinkSection,
    'image-section': ImageSection,
    'section-layout': SectionLayout,
    'numbered-list': NumberedListSection,
  }

  const componentKey = (
    (section.strapi_component ? section.strapi_component : section.__component) || ''
  ).replace('section.', '')
  if (sections[componentKey]) {
    const SectionComponent = sections[componentKey]
    return (
      <SectionComponent section={section} className={className} isDark={isDark} theme={theme} />
    )
  }
  return <section>Section ${section.strapi_component || section.__component} not found.</section>

  // switch (componentKey) {
  //   case 'section.paragraph':
  //     return <ParagraphSection section={section} className={className} />
  //   case 'section.paragraph-with-sticky-image':
  //     return <ParagraphWithStickyImageSection section={section} className={className} />
  //   case 'section.youtube-videos':
  //     return <YoutubeSection section={section} className={className} />
  //   case 'section.form':
  //     return <FormSection section={section} className={className} />
  //
  //   default:
  //     return null
  // }
}

Section.propTypes = {
  section: PropTypes.shape({
    heading: PropTypes.string,
    content: PropTypes.string,
    videos: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string,
      })
    ),
    strapi_component: PropTypes.string,
    __component: PropTypes.string,
  }),
  className: PropTypes.string,
  isDark: PropTypes.bool,
  theme: PropTypes.string,
}

Section.defaultProps = {
  section: {
    heading: '',
    content: '',
    strapi_component: '',
  },
}

export default Section
